import React from 'react';
import { useAppShell } from 'context/AppShellContext';

import LayoutShell from './LayoutShell';

const Layout = ({ children }) => {
  const inAppShell = useAppShell();

  if (inAppShell) {
    return <>{children}</>;
  }

  return <LayoutShell>{children}</LayoutShell>;
};

export default Layout;
